import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isLeaderExperience, isSystemAdmin } from '@/constants/capabilities';
import { getHomePath } from '@/constants/routes';
import { useAuthStore } from '@/stores/auth.store';

interface MobileLeaderGuardProps {
  children: ReactNode;
}

export function MobileLeaderGuard({ children }: MobileLeaderGuardProps) {
  const user = useAuthStore((state) => state.user);

  if (!user) {
    return null;
  }

  if (isSystemAdmin(user)) {
    return <Navigate to={getHomePath(user)} replace />;
  }

  if (!isLeaderExperience(user)) {
    return <Navigate to={getHomePath(user)} replace />;
  }

  return <>{children}</>;
}
